import gql from 'graphql-tag'
import { VersionYearFragment } from '@/graphql/fragments/vehicle'

export const mutation = gql`
  ${VersionYearFragment}
  mutation updateVersionYear($id: Int!, $fields: vehicle_version_year_set_input!) {
    record: update_vehicle_version_year_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...VersionYear
    }
  }
`

export default mutation
